import { render, staticRenderFns } from "./CopilotoMensaje.vue?vue&type=template&id=3b8c7326&"
import script from "./CopilotoMensaje.vue?vue&type=script&lang=ts&"
export * from "./CopilotoMensaje.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports